<template>
    <div class="mb-2 p-2 border rounded step-container">
        <div class="mb-2 step-main-information">
            <div class="d-flex justify-content-between">
                <app-input
                    label="Relating table"
                    :is-required="true"
                    placeholder="users"
                    v-model="relatingTable"
                ></app-input>
                <app-input
                    label="Related table"
                    :is-required="true"
                    placeholder="enrolments"
                    v-model="relatedTable"
                ></app-input>
            </div>
            <div class="d-flex justify-content-between align-items-end">
                <app-select
                    label="Step type"
                    :is-required="true"
                    :is-multiple="false"
                    :options="getStepTypes()"
                    v-model.number="type"
                ></app-select>
                <app-button @click="saveStep" type="success" :class="{disabled: !stepIsReady}">
                    Save step
                </app-button>
            </div>
        </div>
        <div class="filters-container">
            <div class="filters-list">
                <h5>Step filters</h5>
                <table class="table table-bordered">
                    <tr>
                        <th>Column</th>
                        <th>Value</th>
                        <th>Operator</th>
                        <th></th>
                    </tr>
                    <template v-if="filters.length">
                        <tr v-for="(filter, idx) in filters">
                            <td>{{ filter.column }}</td>
                            <td>{{ filter.value }}</td>
                            <td>{{ getOperatorTitle(filter.operator) }}</td>
                            <td>
                                <app-button @click="removeFilter(idx)" type="error">
                                    Remove
                                </app-button>
                            </td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr>
                            <td colspan="4" class="text-center">No filters</td>
                        </tr>
                    </template>
                </table>
            </div>
            <div class="filter-editor">
                <div class="d-flex justify-content-between">
                    <app-input
                        label="Column"
                        :is-required="true"
                        placeholder="users.id"
                        v-model="filterEditor.column"
                    ></app-input>
                    <app-input
                        label="Value"
                        :is-required="true"
                        placeholder="enrolments.user_id"
                        v-model="filterEditor.value"
                    ></app-input>
                </div>
                <div class="d-flex justify-content-between align-items-end">
                    <app-select
                        label="Operator"
                        :is-required="true"
                        :is-multiple="false"
                        :options="getFiltersOperators()"
                        v-model.number="filterEditor.operator"
                    ></app-select>
                    <app-button @click="addFilter" type="success" :class="{disabled: addFilterButtonIsDisabled}">
                        Add filter
                    </app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        initData: {
            type: Object,
            required: true,
        },
        stepTypes: {
            type: Array,
            required: true
        },
        filterOperators: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            filters: this.initData.filters || [],
            filterEditor: {
                column: '',
                value: '',
                operator: this.filterOperators[0].id,
            },
            relatingTable: this.initData.relatingTable || '',
            relatedTable: this.initData.relatedTable || '',
            type: this.initData.type || '',
            id: this.initData.id || generateUID(),
        };
    },
    methods: {
        addFilter() {
            if (!this.filterEditor.column || !this.filterEditor.value) {
                return;
            }

            this.filters.push({
                column: this.filterEditor.column,
                value: this.filterEditor.value,
                operator: this.filterEditor.operator
            });
            this.filterEditor.column = '';
            this.filterEditor.value = '';
            this.filterEditor.operator = this.filterOperators[0].id;
        },
        removeFilter(filterIndex) {
            this.filters = this.filters.filter((item, index) => {
                return index !== filterIndex;
            });
        },
        getStepTypes() {
            return copy(this.stepTypes);
        },
        getFiltersOperators() {
            return copy(this.filterOperators);
        },
        getOperatorTitle(operatorId) {
            return this.filterOperators.find(operator => operator.id === operatorId).title;
        },
        saveStep() {
            if (!this.stepIsReady) {
                return;
            }

            this.$emit('add-step', copy({
                relatingTable: this.relatingTable,
                relatedTable: this.relatedTable,
                type: this.type,
                filters: this.filters,
                id: this.id,
            }));

            this.relatingTable = '';
            this.relatedTable = '';
            this.type = '';
            this.filters = [];
            this.id = generateUID();
        },
    },
    computed: {
        addFilterButtonIsDisabled() {
            return this.filterEditor.column === '' || this.filterEditor.value === '';
        },
        stepIsReady() {
            return this.relatingTable && this.relatedTable && this.type && this.filters.length;
        },
    },
};
</script>
